export type Banners = '80_90' | '90_100' | 'gte100';

export const EXPERIMENT_KEY = 'upsell_jira_global_automations_limit_banner';

export const BANNER_NAME = 'AUTOMATION_LIMIT_AWARENESS' as const;
export const BANNER_HEIGHT = 56;
